// Containers
import PlacesContainer from 'client/containers/dashboard/Places/containers/PlacesContainer'
import PlaceContainer from 'client/containers/dashboard/Places/containers/PlaceContainer'

// Routes
import PlacesMenuRoutes from './routes/PlacesMenuRoutes'
import PlaceUpdateRoutes from './routes/PlaceUpdateRoutes'

const PlacesRoutes = [
  {
    path: '/:username/places',
    component: PlacesContainer,
    routes: [
      {
        path: '/:username/places/:status/:places_id',
        component: PlaceContainer,
        routes: [
          ...PlaceUpdateRoutes
        ]
      },
      ...PlacesMenuRoutes,
    ]
  }
]

export default PlacesRoutes
